import React from 'react';
import { Modal } from 'antd';
import { CustomText, TableWrapper } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';

export const modalColaboradoresExcedenteValorRemuneracao = ({ listaColaboradores, onOk, onCancel, usuario }) => {
  Modal.confirm({
    centered: true,
    width: 850,
    title: (
      <CustomText
        color="var(--text-grey-8)"
        fontSize={16}
      >
        Excedeu o valor previsto para Remuneração Total
      </CustomText>
    ),
    okText: 'Sim',
    cancelText: 'Não',
    onOk,
    onCancel,
    content: (
      <>
        <CustomText
          color="var(--text-grey-8)"
          fontSize="12px"
        >
          Os profissionais listados abaixo excederam o limite de valor previsto na Remuneração Total
        </CustomText>
        <br />
        <br />
        <TableWrapper>
          <table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>
                  <CustomText
                    fontSize="12px"
                    color="var(--text-grey-5)"
                    height="12px"
                    strong
                  >
                    Nome
                  </CustomText>
                </th>
                <th>
                  <CustomText
                    fontSize="12px"
                    color="var(--text-grey-5)"
                    height="12px"
                    strong
                  >
                    Rendimento Base
                  </CustomText>
                </th>
                <th>
                  <CustomText
                    fontSize="12px"
                    color="var(--text-grey-5)"
                    height="12px"
                    strong
                  >
                    Rendimento Total
                  </CustomText>
                </th>
                <th>
                  <CustomText
                    fontSize="12px"
                    color="var(--text-grey-5)"
                    height="12px"
                    strong
                  >
                    Porcentagem Diferença
                  </CustomText>
                </th>
              </tr>
            </thead>
            <tbody>
              {listaColaboradores
                .filter((colaboradorExcedente) => colaboradorExcedente.nome !== usuario.nome)
                .map((colaboradorExcedente) => (
                  <tr key={colaboradorExcedente.funcCodigo}>
                    <td />
                    <td>
                      <CustomText
                        color="var(--text-grey-8)"
                        fontSize="12px"
                        strong
                      >
                        {colaboradorExcedente.nome}
                      </CustomText>
                    </td>
                    <td>
                      <CustomText
                        color="var(--text-grey-6)"
                        fontSize="12px"
                        strong
                      >
                        {moneyFormat(colaboradorExcedente.rendimentoBase)}
                      </CustomText>
                    </td>
                    <td>
                      <CustomText
                        color="var(--text-grey-6)"
                        fontSize="12px"
                        strong
                      >
                        {moneyFormat(colaboradorExcedente.rendimentoTotal)}
                      </CustomText>
                    </td>
                    <td>
                      <CustomText
                        color="var(--success)"
                        fontSize="12px"
                        strong
                      >
                        {colaboradorExcedente.porcentagemDiferenca}%
                      </CustomText>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </TableWrapper>
        <br />
        <CustomText
          color="var(--text-grey-8)"
          fontSize="12px"
        >
          Deseja seguir com o envio?
        </CustomText>
      </>
    ),
  });
};

export const checkCooperatorWithoutESocial = ({ selectedColaboradores, requisicao }) => {
  if (!requisicao) return null;
  const cooperatorsWithoutEsocial = selectedColaboradores
    .map((selected) => requisicao.items.find(({ cooperator }) => cooperator.id === selected)?.cooperator)
    .filter((cooperator) => !cooperator.isEsocialIncluded);
  if (cooperatorsWithoutEsocial.length === 0) return null;
  return Modal.warning({
    centered: true,
    width: 560,
    title: (
      <CustomText
        color="var(--text-grey-8)"
        fontSize={16}
      >
        Admissão do E-social
      </CustomText>
    ),
    okText: 'OK',
    content: (
      <>
        <p>O evento de admissão do E-social dos cooperados abaixo não constam no ambiente do E-social:</p>
        <ul style={{ maxHeight: '170px', overflow: 'auto' }}>
          {cooperatorsWithoutEsocial.map((c) => (
            <li key={c.id}>
              {c.id} - {c.name}
            </li>
          ))}
        </ul>
        <p>Entre em contato com cadastro@{process.env.REACT_APP_EMAIL_HOST}.</p>
      </>
    ),
  });
};
